module.exports = __webpack_public_path__ + "img/CattleyaoneHandedSword_05.5f5508eb.png";